import { IBIReport } from "../../../Interfaces/Geral/RelatoriosBI/RelatoriosBIInterfaces";
import Axios from "../../Config/API";
import Service from "../../Service";

export type TypeModulosBIVendas = "BIVendas";

export type TypeDashboardBI =
    | "BIDashboardLeads"
    | "BIDashboardMarketing"
    | "BIDashboardVisita"
    | "BIDashboardAnalise"
    | "BIDashboardVendas"
    | "BIDashboardEstoque"
    | "BIDashboardPerdas";

export async function GetPowerBIReportVendasService(
    dsModuloBi: TypeModulosBIVendas,
    dsDashBoardBi: TypeDashboardBI
) {
    return Service(
        Axios.get<IBIReport>(
            `/home/powerbireport/getpowerbireportdashboardbi?dsModuloBi=${dsModuloBi}&dsDashBoardBi=${dsDashBoardBi}`
        )
    );
}
